// extracted by mini-css-extract-plugin
export default {"footer":"AiGoodsList_footer__TNM3P"};